import { Link } from 'react-router-dom'

const DAYS_SHORT = {
  monday: 'Mon',
  tuesday: 'Tue',
  wednesday: 'Wed',
  thursday: 'Thu',
  friday: 'Fri',
  saturday: 'Sat',
  sunday: 'Sun'
}

export function ReportCard({ report }) {
  const { report_id, name, prompt, status, schedule_days = [], updated_at } = report

  const isActive = status === 'active'

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 hover:shadow-md transition-shadow">
      <div className="p-4 sm:p-6">
        <div className="flex items-start justify-between gap-2 mb-3">
          <div className="flex-1 min-w-0">
            <Link
              to={`/reports/${report_id}/edit`}
              className="text-base sm:text-lg font-semibold text-gray-900 hover:text-blue-600 transition-colors block"
            >
              {name}
            </Link>
          </div>
          <span className={`flex-shrink-0 inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
            isActive ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800'
          }`}>
            {isActive ? 'Active' : 'Paused'}
          </span>
        </div>

        <p className="text-sm text-gray-600 line-clamp-2 mb-4">
          {prompt}
        </p>

        {schedule_days.length > 0 && (
          <div className="flex flex-wrap gap-1 mb-4">
            {schedule_days.map(day => (
              <span
                key={day}
                className="inline-flex items-center px-2 py-1 rounded text-xs font-medium bg-blue-50 text-blue-700"
              >
                {DAYS_SHORT[day]}
              </span>
            ))}
          </div>
        )}

        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 text-sm">
          <span className="text-gray-500">
            Updated {new Date(updated_at).toLocaleDateString()}
          </span>
          <div className="flex gap-3 sm:gap-2">
            <Link
              to={`/reports/${report_id}/history`}
              className="text-blue-600 hover:text-blue-800 font-medium py-1"
            >
              View History
            </Link>
            <Link
              to={`/reports/${report_id}/edit`}
              className="text-gray-600 hover:text-gray-900 font-medium py-1"
            >
              Edit
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}
